import { render, staticRenderFns } from "./orderService.vue?vue&type=template&id=0087d5b2&"
import script from "./orderService.vue?vue&type=script&lang=js&"
export * from "./orderService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports